import getEnv from '../config'

const isLoggingEnabled = () => getEnv('ENABLE_CONSOLE_LOGS', 'false') === 'true'

export const logger = {
  log: (message, ...args) => {
    if (isLoggingEnabled()) {
      console.log(message, ...args)
    }
  },
  warn: (message, ...args) => {
    if (isLoggingEnabled()) {
      console.warn(message, ...args)
    }
  },
  error: (message, ...args) => {
    // Errors always logged regardless of ENABLE_CONSOLE_LOGS
    console.error(message, ...args)
  },
  debug: (message, ...args) => {
    if (isLoggingEnabled()) {
      console.debug(message, ...args)
    }
  }
}

export default logger
